import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon, MoonIcon } from 'lucide-react';
import { StarsBackground } from './ui/StarsBackground';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-12 px-4 overflow-hidden bg-gradient-to-b from-navy-950 to-navy-900" data-id="element-105">
      <StarsBackground data-id="element-106" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-6 flex flex-col items-center" data-id="element-108">
          <MoonIcon className="w-8 h-8 text-amber-300 mb-4 animate-float" strokeWidth={1.5} data-id="element-109" />
          <span className="text-amber-300 font-body tracking-widest uppercase text-sm font-medium mb-4 block" data-id="element-110">
            El Protocolo de 3 Días para Recuperar tus Noches
          </span>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-bold text-amber-400 mb-6 leading-tight" data-id="element-111">
            S.O.S. SUEÑO INFANTIL
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-2xl mx-auto mb-10" data-id="element-112">
          <h2 className="text-xl md:text-2xl font-body text-cream-50 leading-relaxed font-light" data-id="element-113">
            Deja de sobrevivir al agotamiento y enseña a tu bebé a dormir 6-8
            horas seguidas sin métodos crueles ni culpas.
          </h2>
          <a href="#oferta-precio" className="mt-8 inline-block bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-navy-950 font-bold font-body text-lg py-4 px-10 rounded-full shadow-[0_0_20px_rgba(251,191,36,0.4)] hover:shadow-[0_0_30px_rgba(251,191,36,0.6)] transition-all duration-300 animate-pulse-glow transform hover:-translate-y-1" data-id="element-114">
            SÍ, QUIERO QUE MI BEBÉ DUERMA
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative w-full max-w-lg mx-auto mb-12" data-id="element-115">
          <div className="absolute inset-0 bg-amber-400/20 rounded-2xl blur-xl animate-pulse-glow" data-id="element-116"></div>
          <img src="https://cdn.magicpatterns.com/uploads/cbxeigrDHjtzFmXoFVPWCr/heylloyd-image-1773602612894.png" alt="Bebé llorando en su cuna a las 3:17 AM" className="relative rounded-2xl shadow-2xl border border-amber-500/30 w-full object-cover aspect-[4/3]" data-id="element-117" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1
      }} className="mt-auto animate-bounce" data-id="element-118">
          <ChevronDownIcon className="w-8 h-8 text-amber-300/50" data-id="element-119" />
        </motion.div>
      </div>
    </section>;
}